"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepRouter = void 0;
const core_1 = require("@veeam/core");
class StepRouter extends core_1.Router {
    constructor(interactor, _bodyViewController, childBuilder) {
        super(interactor);
        this._bodyViewController = _bodyViewController;
        this.childBuilder = childBuilder;
        this.bodyViewController = new core_1.RootViewController();
        this.headerViewController = new core_1.RootViewController();
    }
    didLoad() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.bodyViewController.replace(this._bodyViewController || new core_1.StatelessReactViewController());
            if ((_a = this._bodyViewController) === null || _a === void 0 ? void 0 : _a.texts) {
                this.bodyViewController.texts = this._bodyViewController.texts;
            }
            if (this.childBuilder) {
                const { router } = yield this.childBuilder.build();
                yield this.attachChild(router);
                if (router.headerViewController) {
                    this.headerViewController.replace(router.headerViewController);
                }
                if (router.viewController) {
                    this.bodyViewController.replace(router.viewController);
                }
            }
        });
    }
}
exports.StepRouter = StepRouter;
//# sourceMappingURL=StepRouter.js.map